module.exports = __webpack_public_path__ + "static/media/3d-commerce.4c8c8f06.jpg";